import { createAction } from 'redux-actions';

export const getAvailableReports = createAction('GET_AVAIL_REPORTS');
export const setAvailableReports = createAction('SET_AVAIL_REPORTS');
export const setSelectedReport = createAction('SET_SELECTED_REPORT');